import _ from 'lodash';
import React from 'react';
import { projectRoleStatuses } from '~/lookups';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = _.values(projectRoleStatuses);

export default function ProjectRoleStatusFilter({
  placeholder = 'Project Role Status',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
